import React, { useState, useEffect, useRef } from 'react';
import { toast } from 'react-toastify';

import {
  MenuItem,
  Select,
  Input,
  Chip,
  InputLabel,
  Checkbox,
  ListItemText,
  FormControl,
  TextField,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useField } from '@unform/core';
import { find, isEmpty, isEqual } from 'lodash';
import PropTypes from 'prop-types';
import qs from 'querystring';

import { canURL } from '~/helpers';

function CheckComboboxMultiple({
  unique,
  label,
  params,
  title,
  name,
  first,
  hiddens,
  getValue,
  disabled,
  options,
  ...rest
}) {
  const permission = isEqual(canURL(), { read: true });

  const [data, setData] = useState([]);
  const [personName, setPersonName] = React.useState([
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    19,
  ]);
  const [loading, setLoading] = useState(false);

  const inputRef = useRef(null);

  const handleChange = (event) => {
    setPersonName(event.target.value);
  };

  return (
    <FormControl>
      <Select
        id="demo-mutiple-checkbox"
        multiple
        value={personName}
        onChange={handleChange}
        input={<Input size="small" />}
        renderValue={(selected) => selected.join(', ')}
      >
        {options?.map((obj) => (
          <MenuItem key={obj.value} value={obj.label}>
            <Checkbox
              checked={personName.indexOf(obj.label) > -1}
              color="primary"
            />
            <ListItemText primary={obj.value} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

CheckComboboxMultiple.propTypes = {
  unique: PropTypes.string,
  label: PropTypes.string,
  url: PropTypes.string,
  params: PropTypes.objectOf(PropTypes.object),
  title: PropTypes.string,
  name: PropTypes.string.isRequired,
  first: PropTypes.arrayOf(PropTypes.object),
  hiddens: PropTypes.arrayOf(PropTypes.string),
  getValue: PropTypes.func,
  disabled: PropTypes.bool,
};

CheckComboboxMultiple.defaultProps = {
  unique: '',
  label: '',
  url: '',
  params: {},
  title: 'Select',
  first: [],
  hiddens: [],
  getValue: () => {},
  disabled: false,
};

export default CheckComboboxMultiple;
